import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function correlative() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`document-sequence/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`document-sequence/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('document-sequence/create', data);
    }

    function update(data) {
        return axiosInstance.patch('document-sequence/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`document-sequence/delete`, {
            data: {
                id: id
            }
        });
    }
}
